var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/reset-password.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-91066754!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/reset-password.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ResetPassword.vue
// module id = 350
// module chunks = 1